import type { SxProps, Theme } from '../../themes/themes';

export const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    container: {
      borderBottom: `1px solid ${theme.palette.divider}`,
      backgroundColor: theme.palette.background.default,
    },
    breadcrumbsContainer: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: theme.spacing(5),
      marginBottom: theme.spacing(5),
      [theme.breakpoints.down('sm')]: {
        width: `calc(100% - 2*${theme.spacing(5)})`,
        paddingInline: 0,
        overflowX: 'auto',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
      },
    },
    linkBox: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(4),
      marginLeft: theme.spacing(4),
      [theme.breakpoints.up('lg')]: {
        gap: theme.spacing(5),
        marginLeft: theme.spacing(5),
      },
    },
    link: {
      borderBlock: '1px solid transparent',
      ':hover': { borderBottomColor: 'grey.900' },
      whiteSpace: 'nowrap',
      textDecoration: 'none',
      ...theme.typography.h6,
      color: theme.palette.text.breadcrumb,
    },
  };
};
